import { LogCategoryEnum, LoggingLevel } from "../../Enums/shared";
import { POST_ALL_LOGS } from "../../../components/shared/urls"
import IndexedDB from "../../IndexedDB";
import ActivityLogDB from "../../IndexedDB/ActivityLogDB";
import LogUtils from "../../Utils/LogUtils";
import moment from "moment";
import { Dispatch } from "redux";

export interface ILogBase {
  category: LogCategoryEnum;
  elasticIndex: string;
  logLevel: LoggingLevel;
  timestamp: string;
  logData?: any; // Will need to be updated to be union types when new logging is added
  userId: number;
  userName: string;
}

const getDataForLoggingByCategory = (action: any) => {
  const dataToProcess: any = getDefaultActionData(action);
  return action.reportId
    ? {
        reportId: action.reportId,
        ...dataToProcess
      }
    : dataToProcess;
};

const getDefaultActionData = (action: any) => {
  let resultObj: any = { ...action };
  delete resultObj.logCategory;
  delete resultObj.logLevel;

  return resultObj;
};

export const LoggingMiddleware = (store) => (
  next: Dispatch
) => (action: any): Promise<Dispatch> => {
  let state = store.getState();

  if (!!action.logCategory && !!action.logLevel) {
      let currentLog: ILogBase = {
        category: action.logCategory,
        elasticIndex: action.elasticIndex,
        logLevel: action.logLevel,
        timestamp: moment(new Date()).format("MM-DD-YYYY hh:mm:ss a"),
        logData: action.value,
        userId: state.Application.currentUser.id,
        userName: state.Application.currentUser.firstName + " " + state.Application.currentUser.lastName
      };

      IndexedDB.initDb()
        .then(r => {
          ActivityLogDB.saveActivityToLog(currentLog);
        })
        .catch(e => {
          console.log(e);
          //throw error to global error catch
          throw e;
        });
  }

  if (!LogUtils.LogInterval) {
    LogUtils.LogInterval = setInterval(() => {
      let currState = store.getState();
        LogUtils.postLogData(currState.Application.backendURL + "Logging/ActivityLogs", console.info, console.warn);
    }, 10000);
  }

  return next(action);
};
